export default __webpack_public_path__ + "static/media/mc_cv_3.9cf5af6a.jpg";